var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Inline } from 'syf-component-library/ui/spacing';
import { StyledRadio } from '../../../styles/common';
import { StyledText } from '../../../styles/text';
import { colors } from '../../../styles/theme';
import { StyledRadioOptionCard, StyledRadioOptionCardContainer, StyledRadioOptionCardWithIcon, StyledTag } from './subcomponents';
var RadioOptionCard = function (props) {
    var _a = props.checked, checked = _a === void 0 ? false : _a, icon = props.icon, id = props.id, name = props.name, onChange = props.onChange, primaryLabel = props.primaryLabel, primaryValue = props.primaryValue, details = props.details, _b = props.tagBackground, tagBackground = _b === void 0 ? colors.syfYellow : _b, tagContent = props.tagContent, value = props.value, rest = __rest(props, ["checked", "icon", "id", "name", "onChange", "primaryLabel", "primaryValue", "details", "tagBackground", "tagContent", "value"]);
    var handleChange = function () {
        if (typeof onChange === 'function') {
            onChange(value);
        }
    };
    var renderContent = function () {
        return (_jsxs(StyledRadioOptionCardContainer, { children: [_jsxs(StyledRadioOptionCardContainer, { type: "primary", children: [_jsxs("span", { children: [_jsx(StyledText, { weight: "bold", size: "large", as: "span", children: primaryValue }), _jsx(Inline, { size: "xsmall" }), _jsx(StyledText, { lineHeight: 1.3, weight: "bold", size: "regular", color: "black", as: "span", children: primaryLabel })] }), tagContent && (_jsx(StyledTag, { backgroundColor: tagBackground, content: tagContent }))] }), _jsx(StyledRadioOptionCardContainer, { type: "secondary", children: details })] }));
    };
    if (icon) {
        return (_jsxs(StyledRadioOptionCardWithIcon, { children: [icon, renderContent()] }));
    }
    return (_jsx(StyledRadioOptionCard, __assign({ checked: checked }, rest, { children: _jsx(StyledRadio, { id: id, name: name, value: value, checked: checked, onChange: handleChange, children: renderContent() }) })));
};
export default RadioOptionCard;
//# sourceMappingURL=index.js.map